import { EMAIL_CONSENT_STEP } from '../constants';

export const getFormActiveStep = (activeStep: number, totalSteps: number) => {
  if (activeStep + EMAIL_CONSENT_STEP === totalSteps) {
    return totalSteps - 2;
  }
  return activeStep;
};
